import { render, staticRenderFns } from "./SelectedVessel.vue?vue&type=template&id=06c5bd0c"
import script from "./SelectedVessel.vue?vue&type=script&lang=js"
export * from "./SelectedVessel.vue?vue&type=script&lang=js"
import style0 from "./SelectedVessel.vue?vue&type=style&index=0&id=06c5bd0c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports